function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs30"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: -26.307,
  x2: -25.865,
  y1: -33.98,
  y2: -33.98
}, /*#__PURE__*/React.createElement("stop", {
  id: "stop10",
  stopColor: "#e5e5e6",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  id: "stop12",
  stopColor: "#fff",
  offset: 1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "b",
  x1: -597.93,
  x2: -596.42,
  y1: -327.82,
  y2: -327.82
}, /*#__PURE__*/React.createElement("stop", {
  id: "stop15",
  stopColor: "#e5e5e6",
  offset: 0.14
}), /*#__PURE__*/React.createElement("stop", {
  id: "stop17",
  stopColor: "#fff",
  offset: 0.86
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "c",
  x1: -3343.2,
  x2: -3277.6,
  y1: 56.378,
  y2: 56.378,
  gradientTransform: "matrix(1 0 0 1 -170.25 -5205.8)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "d",
  x1: -13006,
  x2: -12968,
  y1: -1013.1,
  y2: -1013.1,
  gradientTransform: "matrix(.99996 0 0 1 -170.25 -5205.8)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "e",
  x1: -3427.3,
  x2: -3361.5,
  y1: 109.02,
  y2: 109.02,
  gradientTransform: "matrix(1 0 0 1 -170.25 -5205.8)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f",
  x1: -13279,
  x2: -13241,
  y1: -1210.7,
  y2: -1210.7,
  gradientTransform: "matrix(.99998 0 0 1 -170.25 -5205.8)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "g",
  x1: -3501.4,
  x2: -3435.7,
  y1: 179.22,
  y2: 179.22,
  gradientTransform: "matrix(1 0 0 1 -170.25 -5205.8)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "h",
  x1: -15078,
  x2: -15040,
  y1: -3325.9,
  y2: -3325.9,
  gradientTransform: "matrix(.99999 0 0 1 -170.25 -5205.8)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "i",
  x1: -2228.3,
  x2: -2162.6,
  y1: 2918.8,
  y2: 2918.8,
  gradientTransform: "translate(-170.25 -5205.8)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "j",
  x1: -13824,
  x2: -13787,
  y1: -1608.4,
  y2: -1608.4,
  gradientTransform: "matrix(.99995 0 0 1 -170.25 -5205.8)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "k",
  x1: -2136.5,
  x2: -2070.9,
  y1: 2869.4,
  y2: 2869.4,
  gradientTransform: "translate(-170.25 -5205.8)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "l",
  x1: -14078,
  x2: -14040,
  y1: -1792,
  y2: -1792,
  gradientTransform: "matrix(.99998 0 0 1 -170.25 -5205.8)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linearGradient272",
  x1: -3586.4,
  x2: -3520.7,
  y1: 322.55,
  y2: 322.55,
  gradientTransform: "matrix(1 0 0 1 -170.25 -5205.8)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "linearGradient274",
  x1: -14529,
  x2: -14492,
  y1: -2471.3,
  y2: -2471.3,
  gradientTransform: "matrix(.99999 0 0 1 -170.25 -5205.8)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#b"
}));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  id: "rect32",
  width: 1566,
  height: 707,
  fill: "none"
});

var _ref4 = /*#__PURE__*/React.createElement("line", {
  id: "line34",
  x1: 231.39,
  x2: 231.39,
  y1: 231.06,
  y2: 496.74,
  fill: "none",
  stroke: "#2d250c",
  strokeMiterlimit: 10
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "path36",
  d: "m173.64 293.22a74.385 74.385 0 1 1 104.64 10.856 74.384 74.384 0 0 1-104.64-10.856z",
  fill: "url(#linearGradient272)",
  fillRule: "evenodd"
});

var _ref6 = /*#__PURE__*/React.createElement("line", {
  id: "line40",
  x1: 226.51,
  x2: 1341,
  y1: 514.55,
  y2: 514.55,
  fill: "none",
  stroke: "#2d250c",
  strokeMiterlimit: 10
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "path42",
  d: "m250.47 502.33a22.667 22.667 0 1 0-6.846 31.315 22.669 22.669 0 0 0 6.846-31.315z",
  fill: "#2d250c",
  fillRule: "evenodd"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "path44",
  d: "m241.89 507.84a12.475 12.475 0 1 0-3.769 17.235 12.476 12.476 0 0 0 3.769-17.235z",
  fill: "url(#linearGradient274)",
  fillRule: "evenodd"
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  id: "line46",
  x1: 452.34,
  x2: 452.34,
  y1: 271.86,
  y2: 508.5,
  fill: "none",
  stroke: "#2d250c",
  strokeMiterlimit: 10
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "path48",
  d: "m407.37 368.72a74.386 74.386 0 1 1 104.22-14.289 74.385 74.385 0 0 1-104.22 14.289z",
  fill: "url(#c)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path52",
  d: "m465.66 496.23a22.668 22.668 0 1 0 5.014 31.662 22.672 22.672 0 0 0-5.014-31.662z",
  fill: "#5d752e"
}), /*#__PURE__*/React.createElement("path", {
  id: "path54",
  d: "m459.68 504.48a12.476 12.476 0 1 0 2.759 17.426 12.481 12.481 0 0 0-2.759-17.426z",
  fill: "url(#d)"
}));

var _ref11 = /*#__PURE__*/React.createElement("line", {
  id: "line56",
  x1: 675.96,
  x2: 675.96,
  y1: 292.9,
  y2: 508.5,
  fill: "none",
  stroke: "#2d250c",
  strokeMiterlimit: 10
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "path58",
  d: "m630.99 388.65a74.386 74.386 0 1 1 104.22-14.288 74.384 74.384 0 0 1-104.22 14.288z",
  fill: "url(#e)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path62",
  d: "m689.28 496.23a22.668 22.668 0 1 0 5.014 31.662 22.672 22.672 0 0 0-5.014-31.662z",
  fill: "#f4c478"
}), /*#__PURE__*/React.createElement("path", {
  id: "path64",
  d: "m683.29 504.48a12.476 12.476 0 1 0 2.758 17.426 12.478 12.478 0 0 0-2.758-17.426z",
  fill: "url(#f)"
}));

var _ref13 = /*#__PURE__*/React.createElement("line", {
  id: "line66",
  x1: 905.92,
  x2: 905.92,
  y1: 237.11,
  y2: 502.8,
  fill: "none",
  stroke: "#2d250c",
  strokeMiterlimit: 10
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "path68",
  d: "m860.95 363.65a74.386 74.386 0 1 1 104.22-14.287 74.383 74.383 0 0 1-104.22 14.287z",
  fill: "url(#g)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path72",
  d: "m925 502.33a22.667 22.667 0 1 0-6.846 31.315 22.669 22.669 0 0 0 6.846-31.315z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path74",
  d: "m916.42 507.84a12.476 12.476 0 1 0-3.77 17.235 12.477 12.477 0 0 0 3.77-17.235z",
  fill: "url(#h)"
}));

var _ref15 = /*#__PURE__*/React.createElement("line", {
  id: "line76",
  x1: 1126.5,
  x2: 1126.5,
  y1: 203.09,
  y2: 514.55,
  fill: "none",
  stroke: "#2d250c",
  strokeMiterlimit: 10
});

var _ref16 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "path78",
  d: "m1126.5 160.7a74.385 74.385 0 1 1-74.385 74.387 74.384 74.384 0 0 1 74.385-74.387z",
  fill: "url(#i)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path82",
  d: "m1139.8 496.23a22.668 22.668 0 1 0 5.013 31.661 22.671 22.671 0 0 0-5.013-31.661z",
  fill: "#5d752e"
}), /*#__PURE__*/React.createElement("path", {
  id: "path84",
  d: "m1133.8 504.48a12.475 12.475 0 1 0 2.759 17.426 12.481 12.481 0 0 0-2.759-17.426z",
  fill: "url(#j)"
}));

var _ref17 = /*#__PURE__*/React.createElement("line", {
  id: "line86",
  x1: 1334.2,
  x2: 1334.2,
  y1: 109.24,
  y2: 514.55,
  fill: "none",
  stroke: "#2d250c",
  strokeMiterlimit: 10
});

var _ref18 = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  id: "path88",
  d: "m1334.2 49a74.385 74.385 0 1 1-74.385 74.387 74.385 74.385 0 0 1 74.385-74.387z",
  fill: "url(#k)"
}), /*#__PURE__*/React.createElement("path", {
  id: "path92",
  d: "m1347.6 496.23a22.667 22.667 0 1 0 5.014 31.661 22.671 22.671 0 0 0-5.014-31.661z",
  fill: "#f4c478"
}), /*#__PURE__*/React.createElement("path", {
  id: "path94",
  d: "m1341.6 504.48a12.475 12.475 0 1 0 2.758 17.426 12.478 12.478 0 0 0-2.758-17.426z",
  fill: "url(#l)"
}));

var _ref19 = /*#__PURE__*/React.createElement("g", {
  fill: "#2d250c",
  fontFamily: "Lato-Bold, Lato",
  fontWeight: 700
}, /*#__PURE__*/React.createElement("text", {
  id: "text102",
  x: 907.20099,
  y: 631.73499,
  fontSize: "18px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan96",
  x: 868.61798,
  y: 631.73499
}, "Vali sobiv"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan100",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan98",
  x: 877.784,
  y: 653.33502
}, "pakkuja"))), /*#__PURE__*/React.createElement("text", {
  id: "text106",
  x: 887.88098,
  y: 602.03003,
  fontSize: "48px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan104",
  x: 887.88098,
  y: 602.03003
}, "4.")), /*#__PURE__*/React.createElement("text", {
  id: "text114",
  x: 1125.389,
  y: 631.73499,
  fontSize: "18px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan108",
  x: 1090.599,
  y: 631.73499
}, "S\xF5lmime"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan112",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan110",
  x: 1092.507,
  y: 653.33502
}, "lepingud"))), /*#__PURE__*/React.createElement("text", {
  id: "text118",
  x: 1111.09,
  y: 602.03003,
  fontSize: "48px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan116",
  x: 1111.09,
  y: 602.03003
}, "5.")), /*#__PURE__*/React.createElement("text", {
  id: "text126",
  x: 1336.077,
  y: 631.73499,
  fontSize: "18px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan120",
  x: 1311.876,
  y: 631.73499
}, "Naudi"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan124",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan122",
  x: 1285.744,
  y: 653.33502
}, "renditootlust"))), /*#__PURE__*/React.createElement("text", {
  id: "text130",
  x: 1316.7581,
  y: 602.03003,
  fontSize: "48px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan128",
  x: 1316.7581,
  y: 602.03003
}, "6.")), /*#__PURE__*/React.createElement("text", {
  id: "text138",
  x: 235.63901,
  y: 631.73499,
  fontSize: "18px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan132",
  x: 184.71201,
  y: 631.73499
}, "Teavita meid"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan136",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan134",
  x: 170.276,
  y: 653.33502
}, "oma rendisoovist"))), /*#__PURE__*/React.createElement("text", {
  id: "text142",
  x: 216.319,
  y: 602.03003,
  fontSize: "48px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan140",
  x: 216.319,
  y: 602.03003
}, "1.")), /*#__PURE__*/React.createElement("text", {
  id: "text150",
  x: 452.82599,
  y: 631.73499,
  fontSize: "18px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan144",
  x: 417.285,
  y: 631.73499
}, "Tutvume"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan148",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan146",
  x: 417.63199,
  y: 653.33502
}, "objektiga"))), /*#__PURE__*/React.createElement("text", {
  id: "text154",
  x: 433.50699,
  y: 602.03003,
  fontSize: "48px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan152",
  x: 433.50699,
  y: 602.03003
}, "2.")), /*#__PURE__*/React.createElement("text", {
  id: "text162",
  x: 677.01398,
  y: 631.73499,
  fontSize: "18px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan156",
  x: 648.88898,
  y: 631.73499
}, "Lisame"), /*#__PURE__*/React.createElement("tspan", {
  id: "tspan160",
  fontFamily: "Lato-Light, Lato",
  fontWeight: 300
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan158",
  x: 611.47601,
  y: 653.33502
}, "kuulutuse/ hanke"))), /*#__PURE__*/React.createElement("text", {
  id: "text166",
  x: 657.69501,
  y: 602.03003,
  fontSize: "48px"
}, /*#__PURE__*/React.createElement("tspan", {
  id: "tspan164",
  x: 657.69501,
  y: 602.03003
}, "3.")));

var _ref20 = /*#__PURE__*/React.createElement("g", {
  id: "i4_6"
}, /*#__PURE__*/React.createElement("path", {
  id: "path90",
  d: "m1334.2 195.07a70.684 70.684 0 1 1 70.682-70.683 70.763 70.763 0 0 1-70.682 70.683zm0-129.37a58.684 58.684 0 1 0 58.682 58.685 58.75 58.75 0 0 0-58.682-58.685z",
  fill: "#f4c478"
}), /*#__PURE__*/React.createElement("g", {
  id: "g623"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path168",
  d: "m1367.7 141.16h-68.822a0.6 0.6 0 0 1-0.6-0.6v-44.278a0.6 0.6 0 0 1 0.6-0.6h68.822a0.6 0.6 0 0 1 0.6 0.6v44.277a0.6 0.6 0 0 1-0.6 0.601zm-68.222-1.2h67.624v-43.078h-67.624z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path170",
  d: "m1354.6 137.16h-42.811a0.6 0.6 0 0 1-0.6-0.6 9.115 9.115 0 0 0-9.107-9.1 0.6 0.6 0 0 1-0.6-0.6v-16.877a0.6 0.6 0 0 1 0.6-0.6 9.115 9.115 0 0 0 9.107-9.1 0.6 0.6 0 0 1 0.6-0.6h42.811a0.6 0.6 0 0 1 0.6 0.6 9.113 9.113 0 0 0 9.1 9.1 0.6 0.6 0 0 1 0.6 0.6v16.875a0.6 0.6 0 0 1-0.6 0.6 9.113 9.113 0 0 0-9.1 9.1 0.6 0.6 0 0 1-0.6 0.602zm-42.231-1.2h41.65a10.313 10.313 0 0 1 9.686-9.682v-15.711a10.316 10.316 0 0 1-9.686-9.683h-41.65a10.316 10.316 0 0 1-9.688 9.683v15.716a10.313 10.313 0 0 1 9.688 9.679z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path172",
  d: "m1309.4 122.32a3.9 3.9 0 1 1 3.9-3.9 3.9 3.9 0 0 1-3.9 3.9zm0-6.6a2.7 2.7 0 1 0 2.7 2.7 2.7 2.7 0 0 0-2.7-2.699z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path174",
  d: "m1357 122.32a3.9 3.9 0 1 1 3.9-3.9 3.9 3.9 0 0 1-3.9 3.9zm0-6.6a2.7 2.7 0 1 0 2.7 2.7 2.705 2.705 0 0 0-2.7-2.699z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path176",
  d: "m1367.7 145.88h-68.822a0.6 0.6 0 1 1 0-1.2h68.822a0.6 0.6 0 1 1 0 1.2z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path178",
  d: "m1367.7 153.08h-68.822a0.6 0.6 0 0 1 0-1.2h68.822a0.6 0.6 0 0 1 0 1.2z"
})), /*#__PURE__*/React.createElement("path", {
  id: "path180",
  d: "m1325.4 116.21h2.336a12.281 12.281 0 0 1 0.867-3.373 8.549 8.549 0 0 1 1.623-2.533 6.812 6.812 0 0 1 2.277-1.594 7.169 7.169 0 0 1 2.861-0.554 8.182 8.182 0 0 1 1.686 0.163 6.4 6.4 0 0 1 1.438 0.477 6.13 6.13 0 0 1 1.238 0.776 8.3 8.3 0 0 1 1.1 1.074l-0.441 0.5a0.621 0.621 0 0 1-0.129 0.121 0.317 0.317 0 0 1-0.184 0.05 0.438 0.438 0 0 1-0.271-0.149c-0.106-0.1-0.238-0.221-0.4-0.364s-0.357-0.3-0.589-0.476a4.165 4.165 0 0 0-0.827-0.477 6.209 6.209 0 0 0-1.11-0.363 6.347 6.347 0 0 0-1.458-0.15 6 6 0 0 0-2.349 0.449 5.373 5.373 0 0 0-1.872 1.316 7.154 7.154 0 0 0-1.331 2.149 11.677 11.677 0 0 0-0.739 2.96h8.567v0.427a0.409 0.409 0 0 1-0.106 0.279 0.444 0.444 0 0 1-0.35 0.12h-8.2q-0.043 0.669-0.043 1.381c0 0.2 0 0.391 0.01 0.577s0.012 0.372 0.021 0.561h7.358v0.427a0.411 0.411 0 0 1-0.114 0.293 0.427 0.427 0 0 1-0.326 0.12h-6.846a12.24 12.24 0 0 0 0.7 3.1 7.2 7.2 0 0 0 1.311 2.234 5.193 5.193 0 0 0 1.863 1.352 5.918 5.918 0 0 0 2.349 0.456 6.44 6.44 0 0 0 1.558-0.171 5.606 5.606 0 0 0 1.19-0.434 4.957 4.957 0 0 0 0.881-0.57 7.888 7.888 0 0 0 0.627-0.569q0.255-0.262 0.434-0.434a0.494 0.494 0 0 1 0.307-0.171 0.379 0.379 0 0 1 0.269 0.129l0.527 0.5a9.105 9.105 0 0 1-1.111 1.188 6.452 6.452 0 0 1-1.323 0.912 7 7 0 0 1-1.58 0.583 7.9 7.9 0 0 1-1.851 0.206 7.4 7.4 0 0 1-2.916-0.555 6.339 6.339 0 0 1-2.27-1.623 8.344 8.344 0 0 1-1.559-2.611 13.5 13.5 0 0 1-0.8-3.523h-2.306v-0.84h2.235c-0.01-0.189-0.016-0.377-0.021-0.561 0-0.184-0.01-0.378-0.01-0.577 0-0.465 0.013-0.925 0.043-1.381h-2.25z"
})));

var _ref21 = /*#__PURE__*/React.createElement("g", {
  id: "i4_1",
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path38",
  d: "m286.26 201.78a70.684 70.684 0 1 1-99.424-10.316 70.761 70.761 0 0 1 99.424 10.316zm-100.43 81.547a58.684 58.684 0 1 0 8.57-82.547 58.753 58.753 0 0 0-8.57 82.547z"
}), /*#__PURE__*/React.createElement("g", {
  id: "g512"
}, /*#__PURE__*/React.createElement("path", {
  id: "path182",
  d: "m217.78 227.18h-19.857a0.668 0.668 0 1 1 0-1.335h19.857a0.668 0.668 0 1 1 0 1.335z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path184",
  d: "m216.15 233.91h-18.227a0.667 0.667 0 1 1 0-1.334h18.227a0.667 0.667 0 1 1 0 1.334z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path186",
  d: "m210.35 240.64h-12.427a0.6675 0.6675 0 1 1 0-1.335h12.427a0.6675 0.6675 0 0 1 0 1.335z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path188",
  d: "m218.82 249.02a0.678 0.678 0 0 1-0.334-0.089l-5.664-3.269h-20.416a2.974 2.974 0 0 1-2.973-2.971v-19.4a2.974 2.974 0 0 1 2.973-2.97h28.965a2.973 2.973 0 0 1 2.969 2.97v19.4a2.974 2.974 0 0 1-2.969 2.971h-1.887v2.623c0 0.021 5e-3 0.045 5e-3 0.067a0.67 0.67 0 0 1-0.669 0.668zm-26.414-27.369a1.639 1.639 0 0 0-1.639 1.635v19.4a1.639 1.639 0 0 0 1.639 1.635h20.6a0.65 0.65 0 0 1 0.332 0.091l4.816 2.779v-2.2a0.667 0.667 0 0 1 0.667-0.67h2.555a1.638 1.638 0 0 0 1.635-1.635v-19.4a1.638 1.638 0 0 0-1.635-1.635z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path190",
  d: "m244.54 252.17a14.446 14.446 0 1 1 14.459-14.449 14.47 14.47 0 0 1-14.459 14.449zm0-27.557a13.111 13.111 0 1 0 13.123 13.108 13.131 13.131 0 0 0-13.123-13.108z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path192",
  d: "m266.86 280.65h-44.637a0.667 0.667 0 0 1-0.667-0.667c0-6.625 2.5-12.191 7.216-16.1a25.919 25.919 0 0 1 31.535 0 20.136 20.136 0 0 1 7.217 16.031v0.068a0.668 0.668 0 0 1-0.664 0.668zm-43.961-1.335h43.282c-0.356-13.354-11.383-19.444-21.641-19.444s-21.285 6.09-21.641 19.444z"
})));

var _ref22 = /*#__PURE__*/React.createElement("g", {
  id: "i4_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "path50",
  d: "m495.07 253.16a70.684 70.684 0 1 1-99.033 13.575 70.758 70.758 0 0 1 99.033-13.575zm-78.209 103.05a58.685 58.685 0 1 0-11.264-82.222 58.755 58.755 0 0 0 11.264 82.222z",
  fill: "#5d752e"
}), /*#__PURE__*/React.createElement("g", {
  id: "g527",
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path194",
  d: "m435.31 320.8a22.067 22.067 0 1 1 22.067-22.067 22.093 22.093 0 0 1-22.067 22.067zm0-42.865a20.8 20.8 0 1 0 20.8 20.8 20.822 20.822 0 0 0-20.8-20.8z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path196",
  d: "m418.96 300.21a0.637 0.637 0 0 1-0.638-0.634 18.656 18.656 0 0 1 11.411-17.213 0.63501 0.63501 0 1 1 0.494 1.17 17.386 17.386 0 0 0-10.632 16.043 0.636 0.636 0 0 1-0.635 0.634z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path198",
  d: "m478.65 345.49c-4.087 0-13.181-8.113-18.966-14.326-5.111-5.49-9.285-11.019-11.451-15.17l1.127-0.588c2.084 3.994 6.29 9.562 11.252 14.894 9.6 10.3 17.264 14.976 18.542 13.784s-2.837-9.17-12.43-19.475c-5.287-5.674-10.782-10.593-14.346-12.838l0.677-1.074c3.651 2.3 9.245 7.3 14.6 13.047 6.572 7.058 15.291 18.548 12.368 21.27a1.929 1.929 0 0 1-1.373 0.476z"
})));

var _ref23 = /*#__PURE__*/React.createElement("g", {
  id: "i4_4"
}, /*#__PURE__*/React.createElement("path", {
  id: "path70",
  d: "m948.65 248.09a70.684 70.684 0 1 1-99.033 13.577 70.764 70.764 0 0 1 99.033-13.577zm-78.2 103.05a58.684 58.684 0 1 0-11.267-82.223 58.751 58.751 0 0 0 11.267 82.224z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("g", {
  id: "g574"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path200",
  d: "m936.65 325.35h-63.586a4.723 4.723 0 0 1-4.716-4.719v-45.787a4.722 4.722 0 0 1 4.716-4.715h63.586a4.722 4.722 0 0 1 4.717 4.715v45.787a4.724 4.724 0 0 1-4.717 4.719zm-63.586-53.726a3.225 3.225 0 0 0-3.222 3.22v45.787a3.226 3.226 0 0 0 3.222 3.225h63.586a3.226 3.226 0 0 0 3.223-3.225v-45.787a3.225 3.225 0 0 0-3.223-3.22z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path202",
  d: "m916.41 338.26h-23.09a0.747 0.747 0 0 1-0.722-0.936l3.394-12.912a0.746 0.746 0 0 1 0.721-0.557h16.281a0.747 0.747 0 0 1 0.723 0.557l3.349 12.741a0.748 0.748 0 0 1-0.656 1.107zm-22.122-1.494h21.132l-3-11.417h-15.13z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path204",
  d: "m926.59 341.41h-43.477a0.746 0.746 0 0 1-0.746-0.747v-3.145a0.747 0.747 0 0 1 0.746-0.747h43.477a0.747 0.747 0 0 1 0.746 0.747v3.145a0.746 0.746 0 0 1-0.746 0.747zm-42.729-1.5h41.981v-1.65h-41.981z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path206",
  d: "m936.55 313.04h-63.541a0.747 0.747 0 0 1-0.746-0.749v-37.379a0.746 0.746 0 0 1 0.746-0.747h63.541a0.746 0.746 0 0 1 0.746 0.747v37.379a0.747 0.747 0 0 1-0.746 0.749zm-62.793-1.5h62.046v-35.887h-62.053z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path208",
  d: "m904.86 322.71a2.241 2.241 0 1 1 2.241-2.239 2.247 2.247 0 0 1-2.241 2.239zm0-2.988a0.747 0.747 0 1 0 0.746 0.749 0.752 0.752 0 0 0-0.746-0.749z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#2d2614"
}, /*#__PURE__*/React.createElement("path", {
  id: "path210",
  d: "m909.62 302.61h-27.645a0.431 0.431 0 0 1-0.43-0.43v-19.346a0.432 0.432 0 0 1 0.43-0.431h27.645a0.432 0.432 0 0 1 0.431 0.431v19.351a0.431 0.431 0 0 1-0.431 0.425zm-27.215-0.861h26.784v-18.485h-26.784z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path212",
  d: "m906.2 287.86h-20.292a0.431 0.431 0 1 1 0-0.862h20.292a0.431 0.431 0 1 1 0 0.862z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path214",
  d: "m902.94 292.84h-17.037a0.4305 0.4305 0 1 1 0-0.861h17.037a0.4305 0.4305 0 1 1 0 0.861z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path216",
  d: "m897.1 297.82h-11.2a0.43 0.43 0 1 1 0-0.86h11.2a0.43 0.43 0 1 1 0 0.86z"
})), /*#__PURE__*/React.createElement("path", {
  id: "path218",
  d: "m916.94 284.58a9.865 9.865 0 1 0 9.866 9.864 9.865 9.865 0 0 0-9.866-9.864zm6.45 5.365-8.643 10.444a0.444 0.444 0 0 1-0.15 0.128l-0.113 0.049a0.947 0.947 0 0 1-0.34 0.092h-0.075a1.034 1.034 0 0 1-0.457-0.116l-0.2-0.119a0.885 0.885 0 0 1-0.17-0.191l-0.064-0.081-2.78-4.819a1.046 1.046 0 0 1 0.383-1.43 1.076 1.076 0 0 1 1.432 0.385l2.015 3.492 7.549-9.168a1.084 1.084 0 0 1 1.473-0.146 1.064 1.064 0 0 1 0.381 0.712 1.051 1.051 0 0 1-0.241 0.768z",
  fill: "#2d250c"
})));

var _ref24 = /*#__PURE__*/React.createElement("g", {
  id: "i4_3"
}, /*#__PURE__*/React.createElement("path", {
  id: "path60",
  d: "m718.69 274.09a70.684 70.684 0 1 1-99.033 13.576 70.765 70.765 0 0 1 99.033-13.576zm-78.207 103.05a58.684 58.684 0 1 0-11.267-82.223 58.754 58.754 0 0 0 11.267 82.223z",
  fill: "#f4c478"
}), /*#__PURE__*/React.createElement("g", {
  id: "g547"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path220",
  d: "m707.54 354.34h-63.588a4.723 4.723 0 0 1-4.717-4.718v-45.788a4.721 4.721 0 0 1 4.717-4.714h63.586a4.721 4.721 0 0 1 4.717 4.714v45.788a4.723 4.723 0 0 1-4.715 4.718zm-63.588-53.726a3.225 3.225 0 0 0-3.223 3.22v45.788a3.227 3.227 0 0 0 3.223 3.224h63.586a3.227 3.227 0 0 0 3.223-3.224v-45.788a3.225 3.225 0 0 0-3.223-3.22z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path222",
  d: "m687.3 367.25h-23.09a0.748 0.748 0 0 1-0.723-0.936l3.4-12.912a0.746 0.746 0 0 1 0.72-0.557h16.282a0.747 0.747 0 0 1 0.722 0.557l3.35 12.741a0.748 0.748 0 0 1-0.656 1.107zm-22.122-1.494h21.131l-3-11.417h-15.13z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path224",
  d: "m697.48 370.4h-43.476a0.746 0.746 0 0 1-0.746-0.747v-3.145a0.747 0.747 0 0 1 0.746-0.747h43.476a0.747 0.747 0 0 1 0.746 0.747v3.145a0.746 0.746 0 0 1-0.746 0.747zm-42.728-1.5h41.98v-1.65h-41.98z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path226",
  d: "m707.43 342.03h-63.541a0.747 0.747 0 0 1-0.746-0.748v-37.38a0.746 0.746 0 0 1 0.746-0.747h63.541a0.746 0.746 0 0 1 0.747 0.747v37.38a0.747 0.747 0 0 1-0.747 0.748zm-62.793-1.494h62.046v-35.888h-62.046z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path228",
  d: "m675.75 351.7a2.242 2.242 0 1 1 2.24-2.24 2.248 2.248 0 0 1-2.24 2.24zm0-2.989a0.748 0.748 0 1 0 0.746 0.749 0.752 0.752 0 0 0-0.746-0.749z"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#2d2614"
}, /*#__PURE__*/React.createElement("path", {
  id: "path230",
  d: "m680.52 331.6h-27.645a0.431 0.431 0 0 1-0.431-0.43v-19.345a0.432 0.432 0 0 1 0.431-0.432h27.645a0.431 0.431 0 0 1 0.43 0.432v19.345a0.43 0.43 0 0 1-0.43 0.43zm-27.215-0.861h26.784v-18.485h-26.784z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path232",
  d: "m677.09 316.85h-20.292a0.431 0.431 0 1 1 0-0.862h20.292a0.431 0.431 0 0 1 0 0.862z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path234",
  d: "m673.83 321.83h-17.037a0.431 0.431 0 1 1 0-0.862h17.037a0.431 0.431 0 1 1 0 0.862z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path236",
  d: "m667.99 326.81h-11.2a0.43 0.43 0 1 1 0-0.86h11.2a0.43 0.43 0 1 1 0 0.86z"
})), /*#__PURE__*/React.createElement("path", {
  id: "path238",
  d: "m687.83 313.57a9.865 9.865 0 1 0 9.865 9.864 9.865 9.865 0 0 0-9.865-9.864z",
  fill: "#2d250c"
}), /*#__PURE__*/React.createElement("path", {
  id: "path240",
  d: "m688.93 319.13v3.69h3.5v1.647h-3.5v3.708h-1.8v-3.708h-3.48v-1.647h3.483v-3.69z",
  fill: "#fff"
})));

var _ref25 = /*#__PURE__*/React.createElement("g", {
  id: "i4_5"
}, /*#__PURE__*/React.createElement("path", {
  id: "path80",
  d: "m1126.5 305.77a70.684 70.684 0 1 1 70.681-70.683 70.763 70.763 0 0 1-70.681 70.683zm0-129.37a58.684 58.684 0 1 0 58.681 58.685 58.75 58.75 0 0 0-58.681-58.685z",
  fill: "#5d752e"
}), /*#__PURE__*/React.createElement("g", {
  id: "g600",
  fill: "#2d250c"
}, /*#__PURE__*/React.createElement("path", {
  id: "path242",
  d: "m1125.2 278.17h-0.053l-9.572-0.773a0.657 0.657 0 0 1-0.5-1l5.133-8.2a0.654 0.654 0 0 1 1.142 0.056l4.444 8.971a0.656 0.656 0 0 1-0.59 0.947zm-8.443-2 7.341 0.594-3.408-6.88z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path244",
  d: "m1121.2 277.84a0.266 0.266 0 0 1-0.053 0l-5.568-0.446a0.655 0.655 0 0 1-0.535-0.359 0.662 0.662 0 0 1 0.029-0.644l3-4.8a0.659 0.659 0 0 1 0.93-0.194 6.641 6.641 0 0 1 2.183 2.515 6.543 6.543 0 0 1 0.668 3.314 0.654 0.654 0 0 1-0.654 0.614zm-4.441-1.671 3.785 0.3a5.274 5.274 0 0 0-0.533-1.979 5.21 5.21 0 0 0-1.211-1.591z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path246",
  d: "m1125.2 278.17h-0.053l-9.572-0.773a0.657 0.657 0 0 1-0.5-1l5.133-8.2a0.628 0.628 0 0 1 0.264-0.24l30.138-14.905a0.656 0.656 0 0 1 0.879 0.3l4.443 8.977a0.66 0.66 0 0 1-0.3 0.88l-1.063 0.521-29.076 14.377a0.661 0.661 0 0 1-0.293 0.063zm-8.443-2 8.316 0.672 28.914-14.3 0.473-0.231-3.86-7.8-1.088 0.538-28.3 13.992z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path248",
  d: "m1125.4 266.94h-26a0.655 0.655 0 0 1-0.656-0.655v-64.169a0.656 0.656 0 0 1 0.656-0.658h47.284a0.656 0.656 0 0 1 0.657 0.658v53.644a0.66 0.66 0 0 1-0.364 0.59l-21.285 10.523a0.671 0.671 0 0 1-0.292 0.067zm-25.346-1.312h25.194l20.783-10.275v-52.582h-45.977z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path250",
  d: "m1137.3 223.03h-28.537a0.6565 0.6565 0 0 1 0-1.313h28.537a0.6565 0.6565 0 1 1 0 1.313z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path252",
  d: "m1124.6 232.91h-15.854a0.6565 0.6565 0 0 1 0-1.313h15.854a0.6565 0.6565 0 1 1 0 1.313z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path254",
  d: "m1132.6 242.8h-23.883a0.656 0.656 0 0 1 0-1.312h23.883a0.656 0.656 0 1 1 0 1.312z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path256",
  d: "m1130.8 252.67h-22.043a0.656 0.656 0 0 1 0-1.312h22.043a0.656 0.656 0 1 1 0 1.312z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path258",
  d: "m1138.6 271.55a0.682 0.682 0 0 1-0.272-0.057 0.661 0.661 0 0 1-0.361-0.429l-2.644-9.861a0.655 0.655 0 0 1 0.341-0.756l5.135-2.541a0.655 0.655 0 0 1 0.924 0.418l2.646 9.867a0.653 0.653 0 0 1-0.343 0.757l-5.135 2.535a0.655 0.655 0 0 1-0.291 0.067zm-1.869-10.166 2.3 8.568 3.935-1.942-2.3-8.572z"
}), /*#__PURE__*/React.createElement("path", {
  id: "path260",
  d: "m1155.4 263.27a0.653 0.653 0 0 1-0.588-0.364l-4.444-8.978a0.657 0.657 0 0 1 0.3-0.879l2.5-1.234a2.179 2.179 0 0 1 0.973-0.228 2.228 2.228 0 0 1 1.986 1.233l3.065 6.189a2.214 2.214 0 0 1-1 2.959l-2.5 1.234a0.643 0.643 0 0 1-0.292 0.068zm-3.565-9.336 3.86 7.8 1.908-0.942a0.893 0.893 0 0 0 0.453-0.521 0.88 0.88 0 0 0-0.045-0.678l-3.066-6.193a0.9 0.9 0 0 0-0.809-0.5 0.858 0.858 0 0 0-0.391 0.092z"
})));

var SvgIllustration44 = function SvgIllustration44(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg266",
    width: 1566,
    height: 707,
    viewBox: "0 0 1566 707",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIllustration44, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/illustration4_4.7d10f0dc.svg";
export { ForwardRef as ReactComponent };